// import React, { useState } from "react";
import React, { useState, useEffect } from "react";
// import { NavLink } from "react-router-dom";
import { NavLink, useNavigate, useLocation } from "react-router-dom";

import FormContactUs from "../Pages/formContactUs";
import HeaderLogo from "../PicsForPages/logo.png";

function Header() {
  const [isFreeQuoteVisible, setIsFreeQuoteVisible] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const openContactForm = () => {
    setIsFreeQuoteVisible(true);

    if (location.pathname !== "/getintouch") {
      navigate("/getintouch");
    }
  };

  // const hideFormContactUs = () => {
  //   setIsFreeQuoteVisible(false);
  // };

  const hideFormContactUs = () => {
    setIsFreeQuoteVisible(false);

    if (location.pathname === "/getintouch") {
      navigate(-1); // go back to previous page
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const getHref = (type, value) => {
    switch (type) {
      case "email":
        return `mailto:${value}`;
      case "phone":
        return `tel:${value}`;
      case "map":
        return `https://www.google.com/maps?q=${encodeURIComponent(value)}`;
      default:
        return "#";
    }
  };

  const contactInfo = [
    {
      label: "Email:",
      value: "info@corneliuswoods.net",
      type: "email",
    },
    {
      label: "Call Us:",
      value: "+18886220033",
      display: "(888) 622-0033",
      type: "phone",
    },
    {
      label: "Address:",
      value: "19181 Zion Ave, Cornelius, NC 28031",
      type: "map",
    },
  ];

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    if (location.pathname === "/getintouch") {
      setIsFreeQuoteVisible(true);
    } else {
      setIsFreeQuoteVisible(false);
    }
  }, [location.pathname]);

  return (
    <div className="headerParent">
      <div className="headerBox">
        <div className="headerTopParent">
          <div className="headerTopBox">
            <span className="headerTopBoxLeft"></span>
            <span className="headerTopBoxRight">
              <span className="headerTopBoxRightBox">
                {contactInfo.map((item, index) => (
                  <span className="headerTopBoxRightBoxSections00" key={index}>
                    <span className="headerTopBoxRightBoxSectionLabel">
                      {item.label}
                    </span>

                    <a
                      href={getHref(item.type, item.value)}
                      className="headerTopBoxRightBoxSectionInput"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>{item.display || item.value} </span>
                    </a>
                  </span>
                ))}
              </span>
            </span>
          </div>
        </div>

        <div className="headerBottomParent">
          <div className="headerBottomBox">
            <NavLink to="/" className="headerBottomBoxLeft">
              <img
                fetchPriority="high"
                loading="eager"
                src={HeaderLogo}
                alt="HeaderLogo"
                className="headerBottomBoxLeftLogo"
                onClick={scrollToTop}
              />
            </NavLink>
            <span className="headerBottomBoxRight">
              <span className="headerBottomBoxRightBox">
                <span className="headerBottomBoxRightBoxList">
                  <NavLink
                    to="/"
                    className={({ isActive }) =>
                      isActive
                        ? "headerBottomBoxRightBoxListLink activeLink"
                        : "headerBottomBoxRightBoxListLink"
                    }
                    onClick={scrollToTop}
                  >
                    HOME
                  </NavLink>
                </span>

                <span className="headerBottomBoxRightBoxList">
                  <NavLink
                    to="/floorplans"
                    className={({ isActive }) =>
                      isActive
                        ? "headerBottomBoxRightBoxListLink activeLink"
                        : "headerBottomBoxRightBoxListLink"
                    }
                    onClick={scrollToTop}
                  >
                    FLOORPLANS
                  </NavLink>
                </span>

                <span className="headerBottomBoxRightBoxList">
                  <NavLink
                    to="/amenities"
                    className={({ isActive }) =>
                      isActive
                        ? "headerBottomBoxRightBoxListLink activeLink"
                        : "headerBottomBoxRightBoxListLink"
                    }
                    onClick={scrollToTop}
                  >
                    AMENITIES
                  </NavLink>
                </span>

                <span className="headerBottomBoxRightBoxList">
                  <NavLink
                    to="/local-information"
                    className={({ isActive }) =>
                      isActive
                        ? "headerBottomBoxRightBoxListLink activeLink"
                        : "headerBottomBoxRightBoxListLink"
                    }
                    onClick={scrollToTop}
                  >
                    LOCAL INFORMATION
                  </NavLink>
                </span>

                <span className="headerBottomBoxRightBoxList">
                  <NavLink
                    to="/about-us"
                    className={({ isActive }) =>
                      isActive
                        ? "headerBottomBoxRightBoxListLink activeLink"
                        : "headerBottomBoxRightBoxListLink"
                    }
                    onClick={scrollToTop}
                  >
                    ABOUT US
                  </NavLink>
                </span>

                <span
                  className="headerBottomBoxRightBoxBotton"
                  // onClick={() => setIsFreeQuoteVisible(true)}
                  onClick={openContactForm}
                >
                  Get In Touch
                </span>

                {isFreeQuoteVisible && (
                  <div
                    className="FormContactUsParent"
                    // onClick={handleOutsideClick}
                  >
                    <div className="FormContactUsBox">
                      <FormContactUs />

                      <span
                        className="FormContactUsCloseButton"
                        onClick={hideFormContactUs}
                      >
                        <span>X</span>
                      </span>
                    </div>
                  </div>
                )}
              </span>
            </span>

            <div className="headerMenuMobileView">
              {/* MENU BUTTON */}
              {!isMenuOpen && (
                <span
                  alt="Menu Button"
                  id="menubtn"
                  onClick={toggleMenu}
                ></span>
              )}

              {/* CLOSE BUTTON */}
              {isMenuOpen && (
                <span id="closebtn" onClick={toggleMenu}>
                  X
                </span>
              )}

              {/* MENU LIST */}
              {isMenuOpen && (
                <div className="headerMenuMobileViewlist">
                  <NavLink
                    to="/"
                    onClick={() => {
                      scrollToTop();
                      setIsMenuOpen(false);
                    }}
                    className={({ isActive }) =>
                      isActive
                        ? "headerMenuMobileViewListLink activeLink"
                        : "headerMenuMobileViewListLink"
                    }
                  >
                    HOME
                  </NavLink>

                  <NavLink
                    to="/floorplans"
                    onClick={() => {
                      scrollToTop();
                      setIsMenuOpen(false);
                    }}
                    className={({ isActive }) =>
                      isActive
                        ? "headerMenuMobileViewListLink activeLink"
                        : "headerMenuMobileViewListLink"
                    }
                  >
                    FLOORPLANS
                  </NavLink>

                  <NavLink
                    to="/amenities"
                    onClick={() => {
                      scrollToTop();
                      setIsMenuOpen(false);
                    }}
                    className={({ isActive }) =>
                      isActive
                        ? "headerMenuMobileViewListLink activeLink"
                        : "headerMenuMobileViewListLink"
                    }
                  >
                    AMENITIES
                  </NavLink>

                  <NavLink
                    to="/local-information"
                    onClick={() => {
                      scrollToTop();
                      setIsMenuOpen(false);
                    }}
                    className={({ isActive }) =>
                      isActive
                        ? "headerMenuMobileViewListLink activeLink"
                        : "headerMenuMobileViewListLink"
                    }
                  >
                    LOCAL INFORMATION
                  </NavLink>

                  <NavLink
                    to="/about-us"
                    onClick={() => {
                      scrollToTop();
                      setIsMenuOpen(false);
                    }}
                    className={({ isActive }) =>
                      isActive
                        ? "headerMenuMobileViewListLink activeLink"
                        : "headerMenuMobileViewListLink"
                    }
                  >
                    ABOUT US
                  </NavLink>

                  <span
                    className="headerBottomBoxRightBoxBotton"
                    // onClick={() => {
                    //   setIsFreeQuoteVisible(true);
                    // }}
                    onClick={openContactForm}
                  >
                    Get In Touch
                  </span>

                  {isFreeQuoteVisible && (
                    <div
                      className="FormContactUsParent"
                      // onClick={handleOutsideClick}
                    >
                      <div className="FormContactUsBox">
                        <FormContactUs />

                        <span
                          className="FormContactUsCloseButton"
                          onClick={hideFormContactUs}
                        >
                          <span>X</span>
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
